import classNames from 'classnames';
import React, {FC} from 'react';

import styles from './SkeletonLoader.module.css';

export interface SkeletonLoaderProps {
	width?: string | number;
	height?: string | number;
	className?: string;
}

export const SkeletonLoader: FC<SkeletonLoaderProps> = ({width, height, className}) => {
	return (
		<div
			style={{
				width: width ?? '100%',
				height: height ?? '100%',
			}}
			className={classNames(styles.wrapper, className)}
		/>
	);
};
